import React from 'react';
import SlideComponent from '~/components/atom/SlideComponent';
import BndlLoading from '~/components/atom/BndlLoading';
import JustificationContainer from '~/components/atom/JustificationContainer';
import Icon from '~/components/atom/Icon';
import { Heading3 } from '~/components/atom/Typography';
import StatusContainer from '~/components/organism/StatusContainer';

const text = {
  noFlowFound: 'Flow niet gevonden',
  headingFlowToImport: 'Flow importeren',
};

export type Props = {
  /**
   * No flow is found from getFlowDependencies query
   */
  noFlowFound: boolean;

  /**
   * Loading state of the getFlowDependencies query
   */
  isLoading: boolean;

  /**
   * No token value is provided
   */
  noToken: boolean;
};

const ResultWrapper: React.FCC<Props> = ({
  noFlowFound,
  isLoading,
  noToken,
  children,
}) => {
  if (noToken) {
    return null;
  }

  if (isLoading) {
    return <BndlLoading />;
  }

  if (noFlowFound) {
    return (
      <SlideComponent isVisible={true} direction="top" width="100%">
        <JustificationContainer gap="m" width="100%">
          <StatusContainer level="danger" label={text.noFlowFound} />
        </JustificationContainer>
      </SlideComponent>
    );
  }

  return (
    <SlideComponent isVisible={true} direction="top" width="100%">
      <JustificationContainer gap="m" direction="column" width="100%">
        <JustificationContainer
          backgroundColor={{ group: 'primary', variant: 'translucent' }}
          border={{ radius: 's' }}
          padding={['m']}
          width="100%"
          direction="column"
          gap="m"
        >
          <JustificationContainer gap="xs" align="center">
            <Icon name="branches" size="m" strokeWidth={2.2} />
            <Heading3 margin={[null]} size="m">
              {text.headingFlowToImport}
            </Heading3>
          </JustificationContainer>
          {children}
        </JustificationContainer>
      </JustificationContainer>
    </SlideComponent>
  );
};

export default ResultWrapper;
